//配送单
import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL
export default {
  //配送单-封箱-候选人员，由后端返回当前层级内有效配货员（含符合角色的自己）。
  sealingCandidates: () => apiAxios('post', baseURL + '/porder.sealing.candidates', undefined, { isLoading: true, resolveError: true }),
  //配送单-封箱-调整封箱人，支持一次提交 1 至 200 个配送单号。
  sealingAssign: (data) => apiAxios('post', baseURL + '/porder.sealing.assign', data, { isLoading: true, resolveError: true }),
  //配送单-封箱-确认完成，单条与批量共用，提交前需要二次确认。
  sealingComplete: (data) => apiAxios('post', baseURL + '/porder.sealing.complete', data, { isLoading: true, resolveError: true }),
  //配送单-配送单列表
  generalList: (data) => apiAxios('post', baseURL + '/porder.generalList', data),
  //配送单列表进行中的配送单
  porderList: (data) => apiAxios('post', baseURL + '/porder.list', data),
  //配送单-删除配送单
  deletePorder: (data) => apiAxios('post', baseURL + '/porder.deletePorder', data),
  //配送单-状态MAP
  statusMap: (data) => apiAxios('post', baseURL + '/porder.statusMap', data),
  //调整业务采购配货
  allotYGP: (data) => apiAxios('post', baseURL + '/porder.allotYGP', data),
  //修改业务员
  allotY: (data) => apiAxios('post', baseURL + '/porder.allotY', data),
  //修改配货员 
  allotP: (data) => apiAxios('post', baseURL + '/porder.allotP', data),
  //修改配送单备注 
  updateRemark: (data) => apiAxios('post', baseURL + '/porder.updateRemark', data),
  //配送单-FBA-添加FBA标识
  addFbaSign: (data) => apiAxios('post', baseURL + '/porder.addFbaSign', data),
  // STOCKCREW配送单-下载外部商品标PDF
  getOuterLabelPdf: (data) => apiAxios('post', baseURL + '/external.getOuterLabelPdf', data, {
    responseType: 'blob'
  }),
  //配送单-FBA-删除FBA标识
  deleteFbaSign: (data) => apiAxios('post', baseURL + '/porder.deleteFbaSign', data),
  //配送单-FBA-删除FBA标识
  deleteTag: (data) => apiAxios('post', baseURL + '/porder.fba.deleteTag', data),

  //配送单-合单
  mergePorder: (data) => apiAxios('post', baseURL + '/porder.mergePorder', data),
  //配送单-比对多个配送单收件地址是否完全一致
  isPorderAddressSame: (data) => apiAxios('post', baseURL + '/porder.isPorderAddressSame', data),
  //配送单-并单-(关联子单号)
  updateSubPorder: (data) => apiAxios('post', baseURL + '/porder.updateSubPorder', data),
  //配送单-并单-(关联子单号)可关联配送单列表
  mergeableCandidateList: (data) => apiAxios('post', baseURL + '/porder.mergeableCandidateList', data),
  //配送单-拆单(待翻译)
  splitPorderTranslate: (data) => apiAxios('post', baseURL + '/porder.splitPorderTranslate', data),
  //清空FBA数据(匹配及打印的数据)
  deleteMatchData: (data) => apiAxios('post', baseURL + '/porder.fba.deleteMatchData', data),
  //配送单翻译提交
  submitTranslate: (data) => apiAxios('post', baseURL + '/porder.submitTranslate', data),
  //配送单-修改单番商品备注
  updateDetailRemark: (data) => apiAxios('post', baseURL + '/porder.updateDetailRemark', data),

  //配送单-待翻译状态下直接修改提出数
  updatePorderNum: (data) => apiAxios('post', baseURL + '/porder.updatePorderNum', data),
  //配送单-配送单追加商品
  appendPorderDetail: (data) => apiAxios('post', baseURL + '/client.appendPorderDetail', data),

  //配送单-打包-退回-到待翻译
  toWaitTranslate: (data) => apiAxios('post', baseURL + '/porder.toWaitTranslate', data),
  //配送单-退回到临时配送单
  toPorderTemp: (data) => apiAxios('post', baseURL + '/porder.toPorderTemp', data),

  //配送单-打包-获取配送单箱子列表
  freightList: (data) => apiAxios('post', baseURL + '/porder.freightList', data),
  //配送单添加箱子
  addBox: (data) => apiAxios('post', baseURL + '/porder.addBox', data),
  //删除箱子 
  deleteBox: (data) => apiAxios('post', baseURL + '/porder.deleteBox', data),
  //修改箱规
  modifyBoxAttr: (data) => apiAxios('post', baseURL + '/porder.modifyBoxAttr', data),
  //配送单-打包-修改箱重
  modifyBoxWeight: (data) => apiAxios('post', baseURL + '/porder.modifyBoxWeight', data),
  //配送单-打包-批量装箱预览数据
  intoBoxPreview: (data) => apiAxios('post', baseURL + '/porder.intoBoxPreview', data),
  //配送单-打包-批量装箱
  intoBoxSubmit: (data) => apiAxios('post', baseURL + '/porder.intoBoxSubmit', data),
  // 打包-查看单箱装箱信息
  boxDetail: (data) => apiAxios('post', baseURL + '/porder.boxDetail', data),
  // 配送单-打包-从箱内取出
  outBoxSubmit: (data) => apiAxios('post', baseURL + '/porder.outBoxSubmit', data),
  //装箱完了
  completeBox: (data) => apiAxios('post', baseURL + '/porder.completeBox', data),
  //装箱完了取消
  unCompleteBox: (data) => apiAxios('post', baseURL + '/porder.unCompleteBox', data),
  //移箱 
  moveFreightGoods: (data) => apiAxios('post', baseURL + '/porder.moveFreightGoods', data),
  //配送单-打包-单商品多箱取出
  outBoxBatchSubmit: (data) => apiAxios('post', baseURL + '/porder.outBoxBatchSubmit', data),
  //配送单-打包-多商品全部取出
  outBoxAllSubmit: (data) => apiAxios('post', baseURL + '/porder.outBoxAllSubmit', data),
  //配送单-打包-修改箱子是否木箱子
  markWooden: (data) => apiAxios('post', baseURL + '/porder.markWooden', data),
  //装箱完提交给业务
  toWaitOffer: (data) => apiAxios('post', baseURL + '/porder.toWaitOffer', data),
  // 查看单番装箱信息
  sortingBoxDetail: (data) => apiAxios('post', baseURL + '/porder.sortingBoxDetail', data),
  //配送单-待报价-拆单箱号预览
  splitPorderConfirmedPreview: (data) => apiAxios('post', baseURL + '/porder.splitPorderConfirmedPreview', data),
  //配送单-待报价-拆单(待报价)
  splitPorderConfirmed: (data) => apiAxios('post', baseURL + '/porder.splitPorderConfirmed', data),
  //待报价-批量修改箱子的发送方式
  batchUpdateFreightLogistics: (data) => apiAxios('post', baseURL + '/porder.batchUpdateFreightLogistics', data),
  //配送单-待报价-国际运费计算
  predictLogisticsPrice: (data) => apiAxios('post', baseURL + '/porder.predictLogisticsPrice', data),
  //配送单-待报价-配送单当前应该收取的总费用
  porderAmountCurrent: (data) => apiAxios('post', baseURL + '/porder.porderAmountCurrent', data),
  //配送单-待报价-国际运费计算(批量)
  getLogisticsAmountBatch: (data) => apiAxios('post', baseURL + '/porder.getLogisticsAmountBatch', data),
  //配送单-待报价-修改配送单物流方式
  updatePorderLogistics: (data) => apiAxios('post', baseURL + '/porder.updatePorderLogistics', data),
  //配送单-待报价-收费类别选项MAP
  otherFeeTypes: (data) => apiAxios('post', baseURL + '/porder.otherFeeTypes', data),
  //配送单-待报价-设置箱子其他费用
  setPorderOtherFee: (data) => apiAxios('post', baseURL + '/porder.setPorderOtherFee', data),
  //退回给配货装箱
  backToConfirm: (data) => apiAxios('post', baseURL + '/porder.backToConfirm', data),
  //配送单-待报价-提交报价
  submitOffer: (data) => apiAxios('post', baseURL + '/porder.submitOffer', data),
  //退回待报价 
  backToOffer: (data) => apiAxios('post', baseURL + '/porder.backToOffer', data),


  //配送单列表
  // porderList: (data, url) => apiAxios('post', baseURL + '/porder.list.' + url, data),
  //配送单详情 
  porderDetail: (data) => apiAxios('post', baseURL + '/porder.detail', data),






  //批量装箱 
  storeFreight: (data) => apiAxios('post', baseURL + '/porder.storeFreight', data),



  //查看单个箱子内的商品 
  boxDetail: (data) => apiAxios('post', baseURL + '/porder.boxDetail', data),
  //提交到待报价
  toWaitPay: (data) => apiAxios('post', baseURL + '/porder.toWaitPay', data),
  //报价给客户 
  offer: (data) => apiAxios('post', baseURL + '/porder.offer', data),


  //退回待入金 
  backToNotPay: (data) => apiAxios('post', baseURL + '/porder.backToNotPay', data),


  //可选国际物流方式  
  logisticsList: (data) => apiAxios('post', baseURL + '/porder.logisticsList', data),

  //装箱详情(单番商品在各个箱子内的情况)
  freightDetail: (data) => apiAxios('post', baseURL + '/porder.freightDetail', data),

  /* 直接装箱 */
  // 直接装箱-列表
  boxList: (data) => apiAxios('post', baseURL + '/box.list', data),
  listV2: (data) => apiAxios('post', baseURL + '/box.listV2', data),
  // 直接装箱-列表Tab数量
  boxTabCount: (data) => apiAxios('post', baseURL + '/box.tabCount', data),
  boxTabCountV2: (data) => apiAxios('post', baseURL + '/box.tabCountV2', data),
  //直接装箱-入普通仓库
  boxToNormalWms: (data) => apiAxios('post', baseURL + '/box.toNormalWms', data),
  // 直接装箱-入收费仓库
  boxToChargeWms: (data) => apiAxios('post', baseURL + '/box.toChargeWms', data),
  // 直接装箱-生成配送单
  boxToPorder: (data) => apiAxios('post', baseURL + '/box.toPorder', data),

  // 创建地址
  addAddress: (data) => apiAxios('post', baseURL + '/porder.addAddress', data),
  // 修改配送单地址
  updatePorderAddress: (data) => apiAxios('post', baseURL + '/porder.updatePorderAddress', data),
  // 配送单-品名编辑预览
  orderMaterialPreview: (data) => apiAxios('post', baseURL + '/porder.orderMaterialPreview', data),
  // 配送单-品名材质-保存
  setOrderMaterial: (data) => apiAxios('post', baseURL + '/porder.setOrderMaterial', data),

  //配送单-fba-标签编辑
  updateTag: (data) => apiAxios('post', baseURL + '/porder.fba.updateTag', data),
  //配送单-fba-标签修改
  modifyTag: (data) => apiAxios('post', baseURL + '/porder.fba.modifyTag', data),
  //配送单-FBA-修改配送单最终打印数
  updatePorderRealTagPrint: (data) => apiAxios('post', baseURL + '/porder.updatePorderRealTagPrint', data),
  //配送单-获取商品的历史标签
  goodsTagLog: (data) => apiAxios('post', baseURL + '/client.goodsTagLog', data),


  //配送单-fba-标记为已打印
  fbaPrint: (data) => apiAxios('post', baseURL + '/porder.fba.print', data),
  //配送单-FBA-增加标签打印原因
  printReasonStore: (data) => apiAxios('post', baseURL + '/porder.fba.printReasonStore', data),
  //配送单-fba-标签匹配上传
  textMatch: (data) => apiAxios('post', baseURL + '/porder.fba.textMatch', data),
  //配送单-FBA-特殊客户标签上传
  specialClientMatch: (data) => apiAxios('post', baseURL + '/porder.fba.specialClientMatch', data),
  //配送单-获取海外仓库编码
  getWarehouseCode: (data) => apiAxios('post', baseURL + '/porder.getWarehouseCode', data),

  //配送单-出货-批量修改物流单号
  updateExpressNo: (data) => apiAxios('post', baseURL + '/porder.updateExpressNo', data),
  //配送单-出货-国际派送提出
  submitDelivery: (data) => apiAxios('post', baseURL + '/porder.submitDelivery', data),

  //配送单-详情-装箱明细查看
  porderFreightDetailList: (data) => apiAxios('post', baseURL + '/porder.porderFreightDetailList', data),
  //配送单-打包-批量装箱信息打印
  boxDetailBatchPrint: (data) => apiAxios('post', baseURL + '/porder.boxDetailBatchPrint', data),

  //配送单-fba-fba列表
  fbaList: (data) => apiAxios('post', baseURL + '/porder.fba.fbaList', data),
  //配送单-fba-fba列表tab统计
  fbaListTotal: (data) => apiAxios('post', baseURL + '/porder.fba.fbaListTotal', data),
  //配送单-fba-获取下属fba人员
  fbaUserList: (data) => apiAxios('post', baseURL + '/porder.fba.fbaUserList', data),
  //配送单-fba-分配fba人
  setFbaUser: (data) => apiAxios('post', baseURL + '/porder.fba.setFbaUser', data),
  //配送单-fba-fba操作状况
  fbaInfo: (data) => apiAxios('post', baseURL + '/porder.fba.fbaInfo', data),

  // 配送单回退-列表
  backList: (data) => apiAxios('post', baseURL + '/porder.backList', data),
  // 配送单回退-回退费用详情
  backDetail: (data) => apiAxios('post', baseURL + '/porder.backDetail', data),
  //配送单-已出货配送单回退
  backAfterDelivery: (data) => apiAxios('post', baseURL + '/porder.backAfterDelivery', data),
  // 配送单回退-回退原因-列表
  backReasonList: (data) => apiAxios('post', baseURL + '/porder.backReasonList', data),
  //配送单回退-回退原因-设置
  backReasonSet: (data) => apiAxios('post', baseURL + '/porder.backReasonSet', data),
  // 配送单回退-回退收费名义-列表
  backChargeList: (data) => apiAxios('post', baseURL + '/porder.backChargeList', data),
  //配送单回退-回退收费名义-设置
  backChargeSet: (data) => apiAxios('post', baseURL + '/porder.backChargeSet', data),
  //千速唛头数据
  kilospeedMark: (data) => apiAxios('post', baseURL + '/porder.kilospeedMark', data),
  //配送单->业务开始翻译(禁止客户提交)
  isYEditing: (data) => apiAxios('post', baseURL + '/porder.isYEditing', data),
  //配送单-FBA-修改配送单标签数
  updateTagNum: (data) => apiAxios('post', baseURL + '/porder.fba.updateTagNum', data),
  //千速获取数据
  findBOrder: (data) => apiAxios('post', baseURL + '/porder.findBOrder', data),
  //千速发票初始化
  invoiceInitialize: (data) => apiAxios('post', baseURL + '/porder.invoiceInitialize', data),

  //配送单-修改配送单FBA操作数
  updateFbaCompleteNum: (data) => apiAxios('post', baseURL + '/porder.updateFbaCompleteNum', data),
  // 配送单-待报价-检查偏远费
  checkSpecialAddress: (data) => apiAxios('post', baseURL + '/porder.checkSpecialAddress', data),
  //配送单-FBA-扫描历史列表
  fbaScanList: (data) => apiAxios('post', baseURL + '/porder.fba.scanList', data),
  //配送单-FBA-扫描校验
  fbaScan: (data) => apiAxios('post', baseURL + '/porder.fba.scan', data),
  //配送单-FBA-设置fba填写数
  fbaFillNum: (data) => apiAxios('post', baseURL + '/porder.fba.fbaFillNum', data),

  //配送单-废弃申请-申请
  discardCreate: (data) => apiAxios('post', baseURL + '/porder.discard.create', data),
  //配送单-废弃申请-列表
  discardList: (data) => apiAxios('post', baseURL + '/porder.discard.list', data),
  //配送单-废弃申请-修改审核备注
  discardUpdateConfirmRemark: (data) => apiAxios('post', baseURL + '/porder.discard.updateConfirmRemark', data),
  //配送单-废弃申请-删除
  discardDelete: (data) => apiAxios('post', baseURL + '/porder.discard.delete', data),
  //配送单-废弃申请-审核
  discardConfirm: (data) => apiAxios('post', baseURL + '/porder.discard.confirm', data),

  //配送单-获取千速黑名单列表
  findAllBlockImporter: (data) => apiAxios('post', baseURL + '/porder.findAllBlockImporter', data),
  //配送单-FBA-标签批量追加文本
  batchAppendTagText: (data) => apiAxios('post', baseURL + '/porder.fba.batchAppendTagText', data),
  //配送单-FBA-标签批量修改条码格式
  batchModifyCodeType: (data) => apiAxios('post', baseURL + '/porder.fba.batchModifyCodeType', data),
  //配送单-FBA-强制商品编码覆盖第一行文本
  batchGoodsNoCoverTextOne: (data) => apiAxios('post', baseURL + '/porder.fba.batchGoodsNoCoverTextOne', data),

  //配送单-修改跟进备注(与客户同步的)
  followRemarkEdit: (data) => apiAxios('post', baseURL + '/porder.followRemarkEdit', data),
  //配送单-打包-多箱明细查看
  freightDetailBatch: (data) => apiAxios('post', baseURL + '/porder.freightDetailBatch', data),
  //配送单-单商品多箱明细查看
  goodsFreightDetailBatch: (data) => apiAxios('post', baseURL + '/porder.goodsFreightDetailBatch', data),
  //配送单-校验其他费用差值
  checkPorderOtherFee: (data) => apiAxios('post', baseURL + '/porder.checkPorderOtherFee', data),
  //配送单-修改实际纳品数
  updateDeliveryNumber: (data) => apiAxios('post', baseURL + '/porder.updateDeliveryNumber', data),
  //配送单-批量修改实际纳品数
  updateDelivery: (data) => apiAxios('post', baseURL + '/porder.updateDelivery', data),
  //配送单-覆盖为历史标签文本
  setTagTextByNo: (data) => apiAxios('post', baseURL + '/client.setTagTextByNo', data),

  //配送单-亚马逊重置入库计划V2
  inboundPlanResetV2: (data) => apiAxios('post', baseURL + '/porder.inboundPlanResetV2', data),

  //配送单-历史地址-列表
  historyDeliveryAddressList: (data) => apiAxios('post', baseURL + '/porder.historyDeliveryAddressList', data),

}
